import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { removeLocaleFromUrl } from "@faire/web--source/ui/routing/util";
import { route as brandbrandTokenRoute } from "@faire/web-api--source/routes/www/brand/brandToken";
import { route as flashSaleRoute } from "@faire/web-api--source/routes/www/flash-sale";
import { route as posHomeRoute } from "@faire/web-api--source/routes/www/point-of-sale";
import { route as posAboutRoute } from "@faire/web-api--source/routes/www/point-of-sale/about";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { matchPath } from "react-router-dom";

type Arg = {
  hasLinkedPOS: boolean;
};

export const useNonStickyHeader = ({ hasLinkedPOS }: Arg) => {
  const { pathname: pathnameWithMaybeLocale } = useLocation();
  const pathname = useMemo(
    () => removeLocaleFromUrl(pathnameWithMaybeLocale),
    [pathnameWithMaybeLocale]
  );

  return useMemo((): boolean => {
    const nonStickyHeaderPath = [
      {
        path: brandbrandTokenRoute,
        exact: true,
      },
      {
        path: flashSaleRoute,
        exact: true,
      },
      {
        path: posAboutRoute,
        exact: true,
      },
      ...(!hasLinkedPOS
        ? [
            {
              path: posHomeRoute,
              exact: true,
            },
          ]
        : []),
    ].filter(isNotUndefined);
    return nonStickyHeaderPath.some(
      (path) => matchPath(pathname, path) !== null
    );
  }, [pathname, hasLinkedPOS]);
};
